var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactmob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u9875\\u9762-1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5BFC\\u822A\\u56FE\\u6807"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    width: 20,
    height: 20,
    fill: "rgba(255,255,255,0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84",
    d: "M18,14.667A3.333,3.333,0,0,0,18,8",
    transform: "translate(-3 -1.333)",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84-2",
    "data-name": "\\u8DEF\\u5F84",
    d: "M18,14.667h0A3.333,3.333,0,0,0,18,8",
    transform: "translate(-3 -1.333)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84-3",
    "data-name": "\\u8DEF\\u5F84",
    d: "M5.333,8a3.333,3.333,0,1,0,0,6.667",
    transform: "translate(-0.333 -1.333)",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84-4",
    "data-name": "\\u8DEF\\u5F84",
    d: "M5.333,8a3.333,3.333,0,1,0,0,6.667h0",
    transform: "translate(-0.333 -1.333)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84-5",
    "data-name": "\\u8DEF\\u5F84",
    d: "M6,13.667V7A5,5,0,0,1,16,7v6.667a5,5,0,0,1-5,5",
    transform: "translate(-1 -0.333)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactmob);
export default __webpack_public_path__ + "static/media/contactmob.da5a42fefb85b128304e575c9e5d5b2d.svg";
export { ForwardRef as ReactComponent };